import { AuthorizationScheme } from "types/generated";

export const humanizeAuthorizationSchemeName = (scheme: AuthorizationScheme) => {
  return scheme === AuthorizationScheme.LoginPolicies ? "Login policy" : "User management";
};
